import { ChakraBox, TaskInfoCard } from '@equip.health/ui';
import { useHistory } from 'react-router-dom';

import { statusOptions } from '~/components/common/Tasks';
import { PatientTabs } from '~/lib/constants/patients.constants';
import { PatientTabsCollection } from '~/lib/hooks/usePatientTabsCollection';
import { CompServTask } from '~/lib/util/task.util';
import { Path } from '~/routes/constants';

import { RailSection } from './RailSection';
import { RailSectionErrorLabel } from './rightRail.constants';
import { mapCompServTaskToTaskCardProps } from './rightRail.util';

interface OverviewTasksSectionProps {
  isError?: boolean;
  isLoading?: boolean;
  openTasks?: CompServTask[];
  patientId: string;
  totalOpenCount?: number;
}

const OverviewTasksSection = ({
  isError,
  isLoading,
  openTasks = [],
  patientId,
  totalOpenCount,
}: OverviewTasksSectionProps) => {
  const history = useHistory();
  const tasksSubPath = PatientTabsCollection[PatientTabs.TASKS].subPath;

  const goToTask = (taskId: string) => {
    history.push({
      pathname: `${Path.MAUD_PATIENTS}/${patientId}/${tasksSubPath}/${taskId}`,
      state: {
        fromPatientRouteTab: false,
        fromTaskRoute: false,
      },
    });
  };

  const rows = openTasks.map((task) => {
    const cardProps = mapCompServTaskToTaskCardProps(task);
    const handleOpen = () => goToTask(cardProps.id);
    return (
      <ChakraBox
        cursor="pointer"
        id={`overview-task-row__${cardProps.id}`}
        key={cardProps.id}
        onClick={handleOpen}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpen();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <TaskInfoCard
          isStatusReadOnly
          statusOptions={statusOptions}
          {...cardProps}
          isFlat
          titleMaxLines={2}
        />
      </ChakraBox>
    );
  });

  return (
    <RailSection
      action={{
        linkTo: tasksSubPath,
        patientId,
        rightLinkText: 'View all',
      }}
      badge={{
        count: totalOpenCount ?? openTasks.length,
        counterId: 'tasks-open-count',
        description: 'open',
        type: 'counter',
      }}
      emptyCaption="No open tasks"
      errorLabel={RailSectionErrorLabel.Tasks}
      headerText="Tasks"
      id="patient-overview-right-rail-v2__tasks"
      isError={isError}
      isLoading={isLoading}
      rows={rows}
    />
  );
};

export default OverviewTasksSection;
